import React from 'react';
import {AbstractStand} from "./AbstractStand";

export const StandMS = (props) => <AbstractStand height="20" width="60" type={"MS"} {...props}/>;

